import { render, staticRenderFns } from "./FormatSectionThumbnailViewer.vue?vue&type=template&id=4bdcc54b&scoped=true&"
import script from "./FormatSectionThumbnailViewer.vue?vue&type=script&lang=ts&"
export * from "./FormatSectionThumbnailViewer.vue?vue&type=script&lang=ts&"
import style0 from "./FormatSectionThumbnailViewer.vue?vue&type=style&index=0&id=4bdcc54b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bdcc54b",
  null
  
)

export default component.exports